import classes from "./SectionDivider.module.css";

const SectionDivider = () => {
  return <div className={classes["section-divider"]} />;
};

export default SectionDivider;
